<section class="action-sheet" role="dialog" aria-modal="true" [attr.aria-labelledby]="header ? 'action-sheet-title' : null">
  @if (header) {
    <header class="action-sheet-header">
      <h2 id="action-sheet-title" class="action-sheet-title">{{ header }}</h2>
    </header>
  }

  <div class="action-sheet-body">
    @for (button of actionButtons; track button.id) {
      <button
        type="button"
        class="action-sheet-option"
        [class.action-sheet-option-destructive]="button.role === 'destructive'"
        (click)="onSelectAction(button)">
        @if (button.icon) {
          <app-display-icon
            class="action-sheet-icon"
            [border]="false"
            [colour]="button.role === 'destructive' ? iconColourEnum.red : iconColourEnum.secondary"
            [icon]="button.icon">
          </app-display-icon>
        }
        <span class="action-sheet-option-label">{{ button.text }}</span>
      </button>
    }
  </div>

  @if (cancelButtons.length > 0) {
    <footer class="action-sheet-footer">
      @for (button of cancelButtons; track button.id) {
        <button
          type="button"
          class="action-sheet-cancel"
          (click)="onCancel()">
          {{ button.text }}
        </button>
      }
    </footer>
  }
</section>
